export { default } from './AssignSubDepartment.js';